/* eslint-disable @typescript-eslint/no-explicit-any -- complex types not adding much value */
const timeout = 60e3;

const withLongerTimeout = ({ call, ...otherMethods }: any) => {
  const customCall = ({ fetchClient, ...rest }: any) => {
    const customFetch = (url: string, fetchOpts: any) =>
      fetchClient(url, {
        ...fetchOpts,
        timeout,
      });
    return call({
      fetchClient: customFetch,
      ...rest,
    });
  };

  return {
    call: customCall,
    ...otherMethods,
  };
};
/* eslint-enable @typescript-eslint/no-explicit-any -- complex types not adding much value */

export default withLongerTimeout;
